import React from 'react';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';

import './companies.css';

import Layout from 'components/global/Layout/Layout';
import CompanyList from 'components/companies/CompanyList/CompanyList';
import CompaniesNav from '../../components/companies/CompaniesNav/CompaniesNav';
import CompanyFeatureManager from '../../components/companies/CompanyFeatureManager/CompanyFeatureManager';
import CompanyTagManager from '../../components/companies/CompanyTagManager/CompanyTagManager';

class CompaniesPage extends React.Component {
  render() {
    const { location } = this.props;

    return (
      <Layout hasHeader>
        <div className='CompaniesPage-root'>
          <div className='CompaniesPage-left'>
            <CompaniesNav location={location} />
          </div>
          <div className='CompaniesPage-right'>
            {
              location.hash === '' || location.hash === '#list' ?
              <CompanyList /> : null
            }
            {
              location.hash === '#feature' ?
              <CompanyFeatureManager /> : null
            }
            {
              location.hash === '#industry' ?
              <CompanyTagManager /> : null
            }
          </div>
        </div>
      </Layout>
    );
  }
}

const connectedCompaniesPage = connect()(CompaniesPage);

const wrappedCompaniesPage = firebaseConnect()(connectedCompaniesPage);

export default wrappedCompaniesPage;



// WEBPACK FOOTER //
// ./src/routes/companies/companies.js